module.exports = __webpack_public_path__ + "22dc58e3e9aa06488b307b1a58be2f23.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-21.png
// module id = 1976
// module chunks = 0